import React, { useEffect, useState } from "react";
import axios from "axios";

const LeadershipMessage = () => {
  const [leaders, setLeaders] = useState([]);

  useEffect(() => {
    axios.get("http://127.0.0.1:8000/api/members/leadership/")
      .then(res => setLeaders(res.data))
      .catch(err => console.log(err));
  }, []);

  return (
    <section className="leadership-section">
      <div className="container">
        <h2>Message from the CEO</h2>

        {leaders.map((leader) => (
          <div className="leader-card" key={leader.id}>

            <div className="leader-image">
              <img src={leader.photo} alt={leader.name} />
            </div>

            <div className="leader-content">
              <h3>{leader.name}</h3>
              <h4>{leader.position}</h4>
              <p>{leader.message}</p>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default LeadershipMessage;